import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../store';
import { GAME_DB } from '../../db/game';
import { setGameTasks } from '../../store/slices/rallyGame';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { getGameTasks } from '../../api/game-mode/game';
import { useTranslation } from 'react-i18next';
import { API_ERRORS } from '../../app.config.vars/errorCodes';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
const useFetchGameTasks = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    useEffect(() => {
        const fetchGameTasks = async () => {
            try {
                const gameTasks = await getGameTasks();
                if (gameTasks.data && gameTasks.data.length) {
                    await GAME_DB.SET.gameTasks(gameTasks.data);
                    dispatch(setGameTasks(gameTasks.data));
                }
                else if (gameTasks.error?.code === API_ERRORS.noInternet) {
                    const gameTasks = await GAME_DB.GET.gameTasks();
                    if (gameTasks) {
                        dispatch(setGameTasks(gameTasks));
                    }
                    else {
                        dispatch(setIsModalOpen(true));
                        dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                    }
                }
                else {
                    console.log('No access to play game');
                    navigate(APP_ROUTES.rallies);
                }
            }
            catch (error) {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
            }
        };
        fetchGameTasks();
    }, [i18n.language]);
};
export default useFetchGameTasks;
